import angular from 'angular';
import modalConfirmationCart from '../../catalog/modal-confirmation/modal-confirmation.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'ByLastItemsService',
  '$uibModal',
  'CartService',
  'Pagination'
];

class ByLastItemsController {
  constructor($scope, $state, $rootScope, ByLastItemsService, $uibModal, CartService, Pagination) {
    this.$scope = $scope;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.ByLastItemsService = ByLastItemsService;
    this.$uibModal = $uibModal;
    this.CartService = CartService;
    this.paginator = Pagination;
    this.loaded=false;
    this.products = [];
    this.searchingProducts = false;
    this.itemsPerPage = 12;
    this.pagination = {};
    this.sortType = 'name'
    this.sortReverse = false;
  }

  $onInit() {
    this.lastItemsBought();
  }
  decreaseProductQuantity (product) {
    if (product.quantityCart > 1)
      product.quantityCart--;
  }
  increaseProductQuantity (product) {
    product.quantityCart++;
  }
  lastItemsBought() {
    this.ByLastItemsService.getLastItemsBought(this.shCtrl.globals.currentUser.userId).then(response => {
      this.products = response;
      this.loaded=true;

      this.searchingProducts = false;
      this.pagination = this.paginator.getNew(this.itemsPerPage);
      this.pagination.numPages = Math.ceil(this.products.length / this.pagination.perPage);
    }).catch(error => {
      console.log(error)
    })
  }

  doFastSearch(searchText) {
    if (angular.isDefined(searchText) && !angular.equals('')) {
      this.searchingProducts = true;
      this.ByLastItemsService.getProducts(searchText, this.shCtrl.globals.currentUser.userId).then(response => {
        this.products = response;
        this.searchingProducts = false;
        this.pagination = this.paginator.getNew(this.itemsPerPage);
        this.pagination.numPages = Math.ceil(this.products.length / this.pagination.perPage);
      }).catch(error => {
        console.log(error)
      })
    }
  }

  setPagination(itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    this.pagination = this.paginator.getNew(this.itemsPerPage);
    this.pagination.numPages = Math.ceil(this.products.length/this.pagination.perPage);
  }

  addItemToCart(product) {
    if (product.id) {
      let userId = '',
        cart = null;
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      } catch (e) {};
      try {
        cart = this.shCtrl.cart;
      } catch (e) {};
      this.CartService.addItemToCart(product, product.quantityCart, null, null, userId, cart).then(response => {
        if (!response.error) {
          this.$scope.$emit('onUpdateCart');
          let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmationCart,
            controller: 'ModalConfirmationController',
            controllerAs: 'mdCtrl',
            size: 'lg',
            resolve: {
              product: () => product
            }
          });
        } else {
          let options = {
            title: '',
            isHtml: true,
            content: response.message,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        }
      }).catch(reason => {
        let options = {
          title: '',
          isHtml: false,
          content: reason,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      })
    }
  }

  updateFavoriteProducts(product) {
    product.isSettingAsFavorite = true;
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    } catch (e) {}
    if (userId) {
      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };

      this.ByLastItemsService.updateFavoriteProducts(data).then(response => {
        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;
      }).catch(error => {
        product.isSettingAsFavorite = false;
        let options = {
          title: '',
          isHtml: false,
          content: 'Ha ocurrido un error al actualizar el producto',
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }
}

ByLastItemsController.$inject = inject;

export default ByLastItemsController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/by-last-items/by-last-items.controller.js
 **/